<template>
    <b-card class="shadowed">
        <div class="text-center py-4">
            <b-img src="/images/webinars/email.svg" class="mb-4"/>
            <h5 class="text-primary">{{trans('webinars.registration.well_done')}}</h5>
            <div class="col-12 col-md-8 offset-md-2">
                <p class="text-primary">{{trans('webinars.registration.registered_webinar')}} <a :href="ctaLink" rel="noopener noreferrer" class="text-secondary text-underline" target="_blank" @click="trackDescription" @click.middle="trackDescription">{{`${webinarDetails.title} ${trans('webinars.registration.webinar_time')} ${webinarDetails.date_time}`}}</a></p>
                <p class="text-primary">{{trans('webinars.registration.email_description')}}</p>
                <p class="text-primary text-bold">{{trans('webinars.registration.waiting_for_you')}}</p>
            </div>
            <b-button variant="secondary" :to="parseNav(webinarDetailNav)">{{trans('webinars.registration.ok')}}</b-button>
        </div>
    </b-card>
</template>

<script>
    import navMixin from '../../mixins/navMixin';

    export default {
        name: "WebinarRegistrationCompleted",
        props:{
            sessionId: String,
            webinarDetailNav: Object
        },
        data(){
            return{
                ctaLink: '/',
                webinarDetails: {}
            }
        },
        methods:{
            trackDescription(){
                trackEvent('WebinarDescriptionClick', {})
            }
        },
        mounted(){
            this.$axios.get(`/api/rest/webinar/${this.sessionId}/details`)
                .then(res => {
                    this.webinarDetails = res.data.details;
                })
                .catch(err => {
                    console.log(err);
                });

            this.$axios.get(`/api/rest/webinar/${this.sessionId}/getWebinarRedirectUrl`)
                .then(res => {
                    this.ctaLink = res.data.url;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        mixins: [navMixin]
    }
</script>